import { styled } from "baseui";

export const HorizontalStackPanel = styled<
  "div",
  {
    $alignItems?: any;
    $gap?: any;
    $flexWrap?: any;
    $width?: any;
    $justifyContent?: any;
  }
>("div", ({ $alignItems, $gap, $flexWrap, $width, $justifyContent, $theme }) => ({
  display: "flex",
  flexDirection: "row",
  columnGap: $gap ?? $theme.sizing.scale100,
  alignItems: $alignItems ?? "baseline",
  justifyContent: $justifyContent,
  flexWrap: $flexWrap,
  width: $width,
  height: "100%",
}));

export const VerticalStackPanel = styled<"div", { $alignItems?: any; $gap?: any; $height?: any }>(
  "div",
  ({ $height, $alignItems, $gap, $theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: $gap ?? $theme.sizing.scale200,
    alignItems: $alignItems ?? "flex-start",
    // width: '100%',
    height: $height,
    flexWrap: "wrap",
  })
);
